import type { ReactNode } from "react";
import type { TranslationKey } from "../../lib/i18n";
import { useConfig } from "../../state/config-context";

const STATUS_KEYS: Record<string, TranslationKey> = {
  active: "crm.status.active",
  inactive: "crm.status.inactive",
  archived: "crm.status.archived",
  open: "crm.status.open",
  won: "crm.status.won",
  lost: "crm.status.lost",
  pending: "crm.status.pending",
  completed: "crm.status.completed",
  canceled: "crm.status.canceled",
};

function toneFor(status: string): string {
  if (status === "active" || status === "won" || status === "completed") {
    return "positive";
  }
  if (status === "lost" || status === "inactive" || status === "canceled") {
    return "negative";
  }
  return "muted";
}

export function StatusBadge({ status }: { status: string }): ReactNode {
  const { t } = useConfig();
  const key = STATUS_KEYS[status];
  return (
    <span className={`badge badge--${toneFor(status)}`}>{key === undefined ? status : t(key)}</span>
  );
}
